import { Action } from '@ngrx/store';
import { DeviceParametersInterface } from './device-parameters.model';
import {GeneralApiResponseInterface} from "../../layout/main/main.model";

export enum DeviceActionTypes {
  GetDeviceParameters = '[Device] Get Device Parameters',
  GetDeviceParametersCompleted = '[Device] Get Device Parameters Completed',
  ClearState = '[Device] Clear State',
  FetchError = '[Device] Fetch Error',
}

export class GetDeviceParameters implements Action {
  readonly type = DeviceActionTypes.GetDeviceParameters;

  constructor(public parametersId: number) {}
}

export class GetDeviceParametersCompleted implements Action {
  readonly type = DeviceActionTypes.GetDeviceParametersCompleted;

  constructor(public payload: GeneralApiResponseInterface<DeviceParametersInterface[]>) {}
}

export class ClearState implements Action {
  readonly type = DeviceActionTypes.ClearState;
}

export class FetchError implements Action {
  readonly type = DeviceActionTypes.FetchError;

  constructor(public payload: any[]) {}
}

export type DeviceParametersActions = GetDeviceParameters | GetDeviceParametersCompleted | ClearState | FetchError;
